import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Empty } from 'antd';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import {  Spin } from "antd";


import GenSummaryDeclined from './GenSummary';
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function DeclinedQuestions() {
    const editorState = useSelector(state=>state.editor);
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    // console.log("editorState.declinedData",editorState.declinedData)
// let uuid=[];
const uuid = editorState?.declinedData?.length>0&&editorState?.declinedData?.flatMap((item) => {
  if (item.docType !== "Video") {
    return item?.answers?.map((val) => val?.expertImage?.uuid);
  }
  return []; // Ensures `flatMap` doesn't insert `undefined`
});


const groupedByVizQuestionUuid = useMemo(() => {
  return editorState.declinedData.reduce((map, item) => {
    const key = item.vizQuestionUuid;
    if (!map.has(key)) {
      map.set(key, []); 
    }
    map.get(key).push(item); 
    return map;
  }, new Map());
}, [editorState.declinedData]);

    const noDataAvailable = () => {
      return (
        <div className="trendingfilterbar" style={{ textAlign: "center" }}>
           <Empty/>
        </div>
      );
    };
  
  // console.log("editor", editorState)

    const spinner=!editorState.declineIsLoading&&!editorState.ratingBool;
// console.log("vote",!spinner)
  return (
    <div style={{marginTop:"15px"}}>
           
           <Spin size="large" spinning={!spinner} style={{ display: 'flex' ,marginTop:"5%"}} >
           {
       editorState.declinedData.length > 0 && 
      //  <Spin size="large" spinning={editorState.ratingBool} style={{ display: 'flex' ,marginTop:"5%"}} >
       <GenSummaryDeclined dataMap={groupedByVizQuestionUuid} uuid={uuid}/>
      //  </Spin>
      }
       
         </Spin>
        {/* {editorState.declineIsLoading && <SkeletonLoader/>} */}
        {!editorState.declineIsLoading&&editorState.declinedData.length == 0 && noDataAvailable()}
   
    </div>
  )
}
